import { Injectable } from '@angular/core';
import { ClientService } from '@core/client/config.service';
import { ToastService } from './toast.service';

@Injectable({ providedIn: 'root' })
export class HelperService {

    constructor(
        public toastService: ToastService,
        public clientService: ClientService) {
    }

    protected normaliseUrl(urlToNormalise: string) {

        urlToNormalise = urlToNormalise.replace('//', '/');
        urlToNormalise = urlToNormalise.replace(/^([a-zA-Z]+:\/|\/)/, '$1/');
        return urlToNormalise;
    }

    clone<T>(objectToClone) {
        if (!!objectToClone && (typeof objectToClone === 'object' || Array.isArray(objectToClone))) {
            return <T>JSON.parse(JSON.stringify(objectToClone));
        }
        return objectToClone;
    }


    protected throwNotImplementedException() {
        throw new Error('Not implemented yet!');
    }
}
